<div class="container " >
    <div class="row justify-content-center">
        <div class="col-md-11">
            <div class="hero_content">
                <div class="hero-header">
                    <div class="row justify-content-between">
                        <div class="col-md-4">
                            <div [ngClass]="{'addOpacity': myTarget < 98}">
                                <h2 class="text-uppercase">
                                    <span>CAT 2025</span> Course <span class="d-block d-sm-none">Package Maker</span>
                                </h2>
                                <h6 class="d-none d-sm-block">Package Maker</h6>
                            </div>
                        </div>

                        <div class="col-md-7">

                            <div class="stepper-course-package">
                                <div class="stepper-header d-flex justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <img src="https://media.iquanta.in/ui_images/target.webp"
                                            alt="CAT Coaching">
                                        <p class="mb-0 text-uppercase">Set your target <span>percentile</span></p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <img src="https://media.iquanta.in/ui_images/group-people.webp"
                                            alt="CAT Coaching">
                                        <p class="mb-0 text-uppercase">Last year <span>500+</span> students got
                                            <span>99+%ile</span>
                                        </p>
                                    </div>
                                </div>
                                <ngx-slider (mouseup)="setTarget($event)" [(value)]="myTarget"
                                    [options]="options"></ngx-slider>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div>
        <div class="col-md-12 d-none d-sm-block">

            <div class="hero_image position-relative" [ngClass]="{'addOpacity': myTarget < 98}">
                <div class="course-package-left">

                    <div class="curvide-lines">
                        <div class="img-dv">
                            <img src="https://media.iquanta.in/ui_images/new-home/line-01.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4> <span>400+ Live</span> Classes</h4>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="curvide-lines curvide-lines1">
                        <div class="img-dv img-dv1">
                            <img src="https://media.iquanta.in/ui_images/new-home/line-05.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4> <span>24*7</span> Doubt Solving</h4>
                            </div>
                        </div>
                    </div> -->


                    <div class="curvide-lines curvide-lines3">
                        <div class="img-dv img-dv3">
                            <img src="https://media.iquanta.in/ui_images/new-home/line-04.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4> <span>24*7</span> Doubt Solving</h4>
                                <!-- <h4><span>2 Month Crash Course</span><br> included worth ₹19,499</h4> -->
                            </div>
                        </div>
                    </div>


                    <div class="position-cards">

                        <div class="single-card-element" [ngClass]="{'check-active': addonListIds.includes('403')}">
                            <p>CAT<br> Books </p>
                            <span>Latest Material</span>
                            <div (click)="addon('403', '')" class="dot">
                                <i *ngIf="addonListIds.includes('403')" class="bi bi-check-circle-fill"></i>
                            </div>
                            <div class="hover-img position-absolute">
                                <img src="https://media.iquanta.in/ui_images/new-home/hover-Books.webp" alt="CAT Books">
                            </div>

                            <div class="product_price">₹5,499</div>
                        </div>

                        <div class="single-card-element se-03 check-active" >
                            <p>CAT Crash Course   </p>
                            <span>2 Month</span>
                            <div  class="dot">
                                <i  class="bi bi-check-circle-fill"></i>
                            </div>
                            <!-- <div class="hover-img position-absolute">
                                <img src="https://media.iquanta.in/ui_images/new-home/hover-Books.webp">
                            </div> -->

                            <div class="product_price ">Worth ₹19,499</div>
                        </div>

                        <div class="single-card-element se-02"
                            [ngClass]="{'check-active': addonListIds.includes('316')}">
                            <p>Non CAT<br>
                                Exams </p>
                            <span>Other Management
                                Exams Full Course</span>
                            <div (click)="addon('316', '')" class="dot">
                                <i *ngIf="addonListIds.includes('316')" class="bi bi-check-circle-fill"></i>
                            </div>
                            <div class="hover-img position-absolute">
                                <img src="https://media.iquanta.in/ui_images/new-home/hover-non-cat.webp" alt="Other Management Exams Full Course">
                            </div>
                            <div class="product_price">₹19,499</div>

                        </div>

                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="376" height="311" viewBox="0 0 376 311" fill="none">

                        <path *ngIf="!addonListIds.includes('403')"
                            d="M375.5 154.14H363.327C335.491 154.14 309.025 142.058 290.791 121.025L240.709 63.256C222.475 42.2231 196.009 30.1405 168.173 30.1405H41"
                            stroke="url(#paint0_linear_2066_24412)" stroke-width="20" />

                            <path 
                            d="M375.5 154.14 H41" 
                            stroke="url(#paint00_linear_2066_24412)" 
                            stroke-width="20" 
                            fill="none" />

                        <path *ngIf="addonListIds.includes('403')"
                            d="M375.5 154.14H363.327C335.491 154.14 309.025 142.058 290.791 121.025L240.709 63.256C222.475 42.2231 196.009 30.1405 168.173 30.1405H41"
                            stroke="url(#paint00_linear_2066_24412)" stroke-width="20" />


                        <path *ngIf="!addonListIds.includes('316')"
                            d="M375.5 154.14H363.327C335.491 154.14 309.025 166.223 290.791 187.256L240.709 245.025C222.475 266.058 196.009 278.14 168.173 278.14H41"
                            stroke="url(#paint1_linear_2066_24412)" stroke-width="20" />

                        <path *ngIf="addonListIds.includes('316')"
                            d="M375.5 154.14H363.327C335.491 154.14 309.025 166.223 290.791 187.256L240.709 245.025C222.475 266.058 196.009 278.14 168.173 278.14H41"
                            stroke="url(#paint10_linear_2066_24412)" stroke-width="20" />


                        <defs>
                            <linearGradient id="paint0_linear_2066_24412" x1="-3" y1="154.14" x2="381" y2="154.14"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#df6a39" stop-opacity="0" />
                                <stop offset="1" stop-color="#df6a39" stop-opacity="10" />
                            </linearGradient>

                            <linearGradient id="paint00_linear_2066_24412" x1="-3" y1="154.14" x2="381" y2="154.14"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#128233" stop-opacity="0" />
                                <stop offset="1" stop-color="#128233" stop-opacity="10" />
                            </linearGradient>

                            <linearGradient id="paint1_linear_2066_24412" x1="23.5" y1="154.141" x2="381" y2="154.141"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#df6a39" stop-opacity="0" />
                                <stop offset="1" stop-color="#df6a39" stop-opacity="10" />
                            </linearGradient>

                            <linearGradient id="paint10_linear_2066_24412" x1="23.5" y1="154.141" x2="381" y2="154.141"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#128233" stop-opacity="0" />
                                <stop offset="1" stop-color="#128233" stop-opacity="10" />
                            </linearGradient>

                        </defs>
                    </svg>
                </div>
                <div class="course-package-right">

                    <div class="curvide-lines curvide-lines2">
                        <div class="img-dv img-dv2">
                            <img src="https://media.iquanta.in/ui_images/new-home/line-02.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4><span>Exclusive Material</span> </h4>
                                <h5>Non engs. QA </h5>
                                <h5>engs. varc </h5>
                                <h5>lrdi inception </h5>
                                <h5>lrdi essential </h5>
                                <h5>varc essentials </h5>
                            </div>
                        </div>
                    </div>

                    <div class="curvide-lines curvide-lines4">
                        <div class="img-dv img-dv4">
                            <img src="https://media.iquanta.in/ui_images/new-home/line-05.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4> <span>Daily Application</span> Classes</h4>
                                <p>iQuanta’s Unique way of teaching <br>
                                    where mentors help you solve questions <br>
                                    covered in Live classes along with <br>instant doubt solving.</p>
                            </div>
                        </div>
                    </div>


                    <div class="curvide-lines curvide-lines5">
                        <div class="img-dv img-dv5">
                            <img src="https://media.iquanta.in/ui_images/new-home/line-04.webp" alt="CAT Coaching">
                            <div class="img-text">
                                <h4><span>1000+</span> Assignments</h4>
                            </div>
                        </div>
                    </div>

                    <div class="position-cards">
                        <div class="single-card-element se-right check-active">
                            <div class="product_price pp-1">Worth ₹5,499</div>

                            <p>CAT<br> Mocks </p>
                            <span>AI Powered</span>
                            <div class="dot">
                                <i class="bi bi-check-circle-fill"></i>
                            </div>
                            <div class="hover-img1 position-absolute">
                                <img src="https://media.iquanta.in/ui_images/new-home/hover-cat-mocks.webp" alt="CAT Mocks">
                            </div>

                        </div>
                        <div class="single-card-element se-right se-02"
                            [ngClass]="{'check-active': addonListIds.includes('439')}">
                            <p>IIM ABC Batch </p>
                            <span>7500 CAT Level Qs.</span>
                            <div (click)="addon('439', '')" class="dot">
                                <i *ngIf="addonListIds.includes('439')" class="bi bi-check-circle-fill"></i>
                            </div>
                            <div class="hover-img1 bg-white position-absolute">
                                <img src="https://media.iquanta.in/ui_images/new-home/hover-iim-abc.webp" alt="IIM ABC Batch">
                            </div>
                            <div class="product_price">₹5,499</div>

                        </div>
                    </div>

                    <svg class="d-none d-sm-block" xmlns="http://www.w3.org/2000/svg" width="376" height="296"
                        viewBox="0 0 376 296" fill="none">


                        <path
                            d="M0 145.14H12.1725C40.009 145.14 66.4749 133.058 84.709 112.025L134.791 54.256C153.025 33.2231 179.491 21.1405 207.327 21.1405H334.5"
                            stroke="url(#paint001_linear_2066_24402)" stroke-width="20" />

                        <path *ngIf="!addonListIds.includes('439')"
                            d="M0 145.14H12.1725C40.009 145.14 66.4749 157.223 84.709 178.256L134.791 236.025C153.025 257.058 179.491 269.14 207.327 269.14H334.5"
                            stroke="url(#paint11_linear_2066_24402)" stroke-width="20" />

                        <path *ngIf="addonListIds.includes('439')"
                            d="M0 145.14H12.1725C40.009 145.14 66.4749 157.223 84.709 178.256L134.791 236.025C153.025 257.058 179.491 269.14 207.327 269.14H334.5"
                            stroke="url(#paint111_linear_2066_24402)" stroke-width="20" />



                        <defs>


                            <linearGradient id="paint001_linear_2066_24402" x1="-3" y1="154.14" x2="381" y2="154.14"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#128233" stop-opacity="10" />
                                <stop offset="1" stop-color="#128233" stop-opacity="0" />
                            </linearGradient>

                            <linearGradient id="paint11_linear_2066_24402" x1="23.5" y1="154.141" x2="381" y2="154.141"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#df6a39" stop-opacity="10" />
                                <stop offset="1" stop-color="#df6a39" stop-opacity="0" />
                            </linearGradient>

                            <linearGradient id="paint111_linear_2066_24402" x1="23.5" y1="154.141" x2="381" y2="154.141"
                                gradientUnits="userSpaceOnUse">
                                <stop stop-color="#128233" stop-opacity="10" />
                                <stop offset="1" stop-color="#128233" stop-opacity="0" />
                            </linearGradient>

                        </defs>
                    </svg>
                </div>

                <div class="hero_img-phone">
                    <div class="hero_img-phone-plug-right w-embed">
                        <img src="https://media.iquanta.in/ui_images/new-home/right-plug.svg">
                        <!-- <svg class="d-none d-sm-block" width="100%" height="100%" viewBox="0 0 161 91" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_i_2066_24649)">
                                <path
                                    d="M111.162 1.88812C121.533 1.88812 129.941 10.2955 129.941 20.6665L129.941 71.1C129.941 81.471 121.533 89.8784 111.162 89.8784L43.56 89.8784L43.56 1.88812L111.162 1.88812Z"
                                    fill="#F6F6F6"></path>
                            </g>
                            <path
                                d="M111.162 1.88812C121.533 1.88812 129.941 10.2955 129.941 20.6665L129.941 71.1C129.941 81.471 121.533 89.8784 111.162 89.8784L43.56 89.8784L43.56 1.88812L111.162 1.88812Z"
                                stroke="#000000" stroke-width="2"></path>
                            <g filter="url(#filter1_i_2066_24649)">
                                <path
                                    d="M7.88163 15.8383C4.17769 15.8383 1.17505 18.841 1.17505 22.5449V22.5449C1.17505 26.2488 4.17768 29.2515 7.88162 29.2515L43.5606 29.2515L43.5606 15.8383L7.88163 15.8383Z"
                                    fill="#F6F6F6"></path>
                            </g>
                            <path
                                d="M7.88163 15.8383C4.17769 15.8383 1.17505 18.841 1.17505 22.5449V22.5449C1.17505 26.2488 4.17768 29.2515 7.88162 29.2515L43.5606 29.2515L43.5606 15.8383L7.88163 15.8383Z"
                                stroke="#000000" stroke-width="2"></path>
                            <path
                                d="M85.6775 39.4448C89.3814 39.4448 92.384 42.4474 92.384 46.1513V46.1513C92.384 49.8553 89.3814 52.8579 85.6775 52.8579L43.5602 52.8579L43.5602 39.4448L85.6775 39.4448Z"
                                fill="#000000" stroke="#000000" stroke-width="2"></path>
                            <g filter="url(#filter2_i_2066_24649)">
                                <path
                                    d="M7.88163 61.9789C4.17769 61.9789 1.17505 64.9816 1.17505 68.6855V68.6855C1.17505 72.3895 4.17768 75.3921 7.88162 75.3921L43.5606 75.3921L43.5606 61.9789L7.88163 61.9789Z"
                                    fill="#F6F6F6"></path>
                            </g>
                            <path
                                d="M7.88163 61.9789C4.17769 61.9789 1.17505 64.9816 1.17505 68.6855V68.6855C1.17505 72.3895 4.17768 75.3921 7.88162 75.3921L43.5606 75.3921L43.5606 61.9789L7.88163 61.9789Z"
                                stroke="#363636" stroke-width="2"></path>
                            <g filter="url(#filter3_i_2066_24649)">
                                <path
                                    d="M144.428 19.5942C152.725 19.5942 159.45 26.3201 159.45 34.6169L159.45 57.151C159.45 65.4478 152.725 72.1737 144.428 72.1737L129.942 72.1737L129.942 19.5942L144.428 19.5942Z"
                                    fill="#F6F6F6"></path>
                            </g>
                            <path
                                d="M144.428 19.5942C152.725 19.5942 159.45 26.3201 159.45 34.6169L159.45 57.151C159.45 65.4478 152.725 72.1737 144.428 72.1737L129.942 72.1737L129.942 19.5942L144.428 19.5942Z"
                                stroke="#363636" stroke-width="2"></path>
                            <defs>
                                <filter id="filter0_i_2066_24649" x="42.5601" y="0.888123" width="88.3806"
                                    height="89.9902" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape">
                                    </feBlend>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                    </feColorMatrix>
                                    <feOffset dx="-12" dy="10"></feOffset>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                    </feColorMatrix>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24649">
                                    </feBlend>
                                </filter>
                                <filter id="filter1_i_2066_24649" x="0.175049" y="14.8383" width="44.3855"
                                    height="15.4131" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape">
                                    </feBlend>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                    </feColorMatrix>
                                    <feOffset dx="5" dy="5"></feOffset>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                    </feColorMatrix>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24649">
                                    </feBlend>
                                </filter>
                                <filter id="filter2_i_2066_24649" x="0.175049" y="60.9789" width="44.3855"
                                    height="15.4131" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape">
                                    </feBlend>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                    </feColorMatrix>
                                    <feOffset dx="5" dy="5"></feOffset>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                    </feColorMatrix>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24649">
                                    </feBlend>
                                </filter>
                                <filter id="filter3_i_2066_24649" x="128.942" y="18.5942" width="31.5089"
                                    height="54.5795" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape">
                                    </feBlend>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                    </feColorMatrix>
                                    <feOffset dx="-8" dy="8"></feOffset>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                    </feColorMatrix>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24649">
                                    </feBlend>
                                </filter>
                            </defs>
                        </svg> -->
                    </div>
                    <div class="hero_img-phone-plug-left w-embed">
                        <img src="https://media.iquanta.in/ui_images/new-home/left-plug.svg">
                        <!-- <svg width="100%" height="100%" viewBox="0 0 161 106"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_i_2066_24655)">
                                <path
                                    d="M49.7857 9.39887C39.4147 9.39887 31.0073 17.8062 31.0073 28.1773L31.0073 78.6107C31.0073 88.9817 39.4147 97.3891 49.7857 97.3891L99.6826 97.3891L99.6826 9.39887L49.7857 9.39887Z"
                                    fill="#F6F6F6"></path>
                            </g>
                            <path
                                d="M49.7857 9.39887C39.4147 9.39887 31.0073 17.8062 31.0073 28.1773L31.0073 78.6107C31.0073 88.9817 39.4147 97.3891 49.7857 97.3891L99.6826 97.3891L99.6826 9.39887L49.7857 9.39887Z"
                                stroke="#D9D9D9" stroke-width="2"></path>
                            <path
                                d="M49.7857 9.39887C39.4147 9.39887 31.0073 17.8062 31.0073 28.1773L31.0073 78.6107C31.0073 88.9817 39.4147 97.3891 49.7857 97.3891L99.6826 97.3891L99.6826 9.39887L49.7857 9.39887Z"
                                stroke="#363636" stroke-width="2"></path>
                            <g filter="url(#filter1_i_2066_24655)">
                                <path
                                    d="M14.3761 28.7143C7.26458 28.7143 1.49951 34.4794 1.49951 41.5909L1.49951 65.198C1.49951 72.3096 7.26457 78.0747 14.3761 78.0747L31.0084 78.0747L31.0084 28.7143L14.3761 28.7143Z"
                                    fill="#F6F6F6"></path>
                            </g>
                            <path
                                d="M14.3761 28.7143C7.26458 28.7143 1.49951 34.4794 1.49951 41.5909L1.49951 65.198C1.49951 72.3096 7.26457 78.0747 14.3761 78.0747L31.0084 78.0747L31.0084 28.7143L14.3761 28.7143Z"
                                stroke="#D9D9D9" stroke-width="2"></path>
                            <path
                                d="M14.3761 28.7143C7.26458 28.7143 1.49951 34.4794 1.49951 41.5909L1.49951 65.198C1.49951 72.3096 7.26457 78.0747 14.3761 78.0747L31.0084 78.0747L31.0084 28.7143L14.3761 28.7143Z"
                                stroke="#363636" stroke-width="2"></path>
                            <g filter="url(#filter2_i_2066_24655)">
                                <rect width="103.013" height="17.1688" rx="8.58441"
                                    transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.6831 1.88812)" fill="#F6F6F6">
                                </rect>
                            </g>
                            <rect width="103.013" height="17.1688" rx="8.58441"
                                transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.6831 1.88812)" stroke="#363636"
                                stroke-width="2"></rect>
                            <g filter="url(#filter3_i_2066_24655)">
                                <path
                                    d="M68.1677 52.7215L68.1677 46.8881L92.9858 55.0548L78.804 55.0548L78.804 60.8881L53.9858 52.7215L68.1677 52.7215Z"
                                    fill="green"></path>
                            </g>
                            <g filter="url(#filter4_i_2066_24655)">
                                <path
                                    d="M152.531 83.4418C156.235 83.4418 159.237 80.4392 159.237 76.7353V76.7353C159.237 73.0313 156.235 70.0287 152.531 70.0287L116.852 70.0287L116.852 83.4418L152.531 83.4418Z"
                                    fill="#F6F6F6"></path>
                            </g>
                            <path
                                d="M152.531 83.4418C156.235 83.4418 159.237 80.4392 159.237 76.7353V76.7353C159.237 73.0313 156.235 70.0287 152.531 70.0287L116.852 70.0287L116.852 83.4418L152.531 83.4418Z"
                                stroke="#363636" stroke-width="2"></path>
                            <g filter="url(#filter5_i_2066_24655)">
                                <path
                                    d="M152.531 37.3012C156.235 37.3012 159.237 34.2986 159.237 30.5946V30.5946C159.237 26.8907 156.235 23.8881 152.531 23.8881L116.852 23.8881L116.852 37.3012L152.531 37.3012Z"
                                    fill="#F6F6F6"></path>
                            </g>
                            <path
                                d="M152.531 37.3012C156.235 37.3012 159.237 34.2986 159.237 30.5946V30.5946C159.237 26.8907 156.235 23.8881 152.531 23.8881L116.852 23.8881L116.852 37.3012L152.531 37.3012Z"
                                stroke="#363636" stroke-width="2"></path>
                            <defs>
                                <filter id="filter0_i_2066_24655" x="30.0073" y="8.39886" width="70.6753"
                                    height="89.9902" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape">
                                    </feBlend>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                    </feColorMatrix>
                                    <feOffset dx="10" dy="10"></feOffset>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                    </feColorMatrix>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24655">
                                    </feBlend>
                                </filter>
                                <filter id="filter1_i_2066_24655" x="0.499512" y="27.7143" width="31.5089"
                                    height="51.3604" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape">
                                    </feBlend>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                    </feColorMatrix>
                                    <feOffset dx="8" dy="8"></feOffset>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                    </feColorMatrix>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24655">
                                    </feBlend>
                                </filter>
                                <filter id="filter2_i_2066_24655" x="98.6831" y="0.888123" width="19.1688"
                                    height="105.013" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape">
                                    </feBlend>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                    </feColorMatrix>
                                    <feOffset dx="6" dy="6"></feOffset>
                                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                    </feColorMatrix>
                                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24655">
                                    </feBlend>
                                </filter>

                            </defs>
                        </svg> -->
                    </div>
                    <img width="338" loading="eager" alt="CAT Coaching" class="hero_img-phone-frame"
                        src="https://media.iquanta.in/ui_images/mobile-video-bg.webp">

                    <div class="mobile-scrollable-content">

                        <div class="mobile-scrollable-content-inside">

                            <div class="video-mobile-in" *ngIf="!playVideoFlag"
                                (click)="playVideoFlag = !playVideoFlag">
                                <img width="364" loading="eager" alt="CAT 2025 Course"
                                    class="hero_img-phone-screenshot"
                                    [src]="thumbnail">
                            </div>
                            <ng-container *ngIf="playVideoFlag">
                                <iframe loading="lazy"
                                    [src]="videoLinkMain"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowfullscreen=""></iframe>
                            </ng-container>

                            <div class="content">
                                <div class="inside-box-mobile d-flex justify-content-between align-items-center">
                                    <div>
                                        <h2 class="f-bold">CAT 2025 New Batch</h2>
                                        <h6>Flagship Full Course | Starting From April</h6>
                                    </div>
                                    <div class="text-right rating">
                                        <p>
                                            <i class="bi bi-star-fill"></i>
                                            <i class="bi bi-star-fill"></i>
                                            <i class="bi bi-star-fill"></i>
                                            <i class="bi bi-star-fill"></i>
                                            <i class="bi bi-star-fill"></i>
                                        </p>
                                        <span class="rating-text f-medium">41894 Reviews</span>
                                    </div>

                                </div>

                                <div class="contest-list-card">
                                    <p [innerHTML]="productDetails?.description | safeHtml"></p>
                                </div>

                                <!-- <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div>

                                <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div>

                                <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div>

                                <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div>

                                <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div>

                                <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div>

                                <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div>

                                <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div>
                                <div class="chips-inside-mobile d-flex f-bold">
                                    <span>20,000+ Questions</span>
                                    <span>20,000+ Questions</span>
                                </div> -->

                                <!-- <p>Grab the formula book, plan your prep with a timetable, and get mentored by experts — all in one place.</p> -->
                            </div>
                        </div>

                    </div>


                    <div class="course-buying-card d-sm-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center pl-3">
                            <h2 class="mb-0">{{totalAmount|currency}}</h2>
                            <span class="ml-2"><del>{{priceObj?.actual_price|currency}}</del></span>
                        </div>
                        <button (click)="buynow()" class="btn buy_now">Buy Now</button>
                    </div>

                 

                </div>

                <div class="extra-btns extra-btns-left d-sm-flex justify-content-between align-items-center">
                    <button (click)="gotosection('why_iquanta_is_best')" class="pushable pushone"><div class="front">iQuanta Features</div></button>
                    <button (click)="gotosection('feedback')" class="pushable pushtwo"><div class="front">iQuanta Toppers & Results</div></button>
                </div>

                <div class="extra-btns extra-btns-right d-sm-flex justify-content-between align-items-center">
                    <button (click)="openLeadForm()" class="pushable pushthree"><div class="front"> Still Confused? Talk to a CAT Counsellor </div></button>
                </div>

            </div>
        </div>

        <div class="col-md-12  d-block d-sm-none">

            <div #sectionRef class="pb-4" id="sectionRef" [ngClass]="{'addOpacity': myTarget < 98}">
                <div #startSentinel class="sentinel"></div>
                <div class="add-ons-wrapper">
                    <div class="hero_image position-relative">
                        <div class="hero_img-phone">
                            <div class="hero_img-phone-plug-right w-embed">
                                <img src="https://media.iquanta.in/ui_images/new-home/right-plug.svg">
                                <!-- <svg width="100%" height="100%" viewBox="0 0 161 91" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_i_2066_24649)">
                                        <path
                                            d="M111.162 1.88812C121.533 1.88812 129.941 10.2955 129.941 20.6665L129.941 71.1C129.941 81.471 121.533 89.8784 111.162 89.8784L43.56 89.8784L43.56 1.88812L111.162 1.88812Z"
                                            fill="#F6F6F6"></path>
                                    </g>
                                    <path
                                        d="M111.162 1.88812C121.533 1.88812 129.941 10.2955 129.941 20.6665L129.941 71.1C129.941 81.471 121.533 89.8784 111.162 89.8784L43.56 89.8784L43.56 1.88812L111.162 1.88812Z"
                                        stroke="#000000" stroke-width="2"></path>
                                    <g filter="url(#filter1_i_2066_24649)">
                                        <path
                                            d="M7.88163 15.8383C4.17769 15.8383 1.17505 18.841 1.17505 22.5449V22.5449C1.17505 26.2488 4.17768 29.2515 7.88162 29.2515L43.5606 29.2515L43.5606 15.8383L7.88163 15.8383Z"
                                            fill="#F6F6F6"></path>
                                    </g>
                                    <path
                                        d="M7.88163 15.8383C4.17769 15.8383 1.17505 18.841 1.17505 22.5449V22.5449C1.17505 26.2488 4.17768 29.2515 7.88162 29.2515L43.5606 29.2515L43.5606 15.8383L7.88163 15.8383Z"
                                        stroke="#000000" stroke-width="2"></path>
                                    <path
                                        d="M85.6775 39.4448C89.3814 39.4448 92.384 42.4474 92.384 46.1513V46.1513C92.384 49.8553 89.3814 52.8579 85.6775 52.8579L43.5602 52.8579L43.5602 39.4448L85.6775 39.4448Z"
                                        fill="#000000" stroke="#000000" stroke-width="2"></path>
                                    <g filter="url(#filter2_i_2066_24649)">
                                        <path
                                            d="M7.88163 61.9789C4.17769 61.9789 1.17505 64.9816 1.17505 68.6855V68.6855C1.17505 72.3895 4.17768 75.3921 7.88162 75.3921L43.5606 75.3921L43.5606 61.9789L7.88163 61.9789Z"
                                            fill="#F6F6F6"></path>
                                    </g>
                                    <path
                                        d="M7.88163 61.9789C4.17769 61.9789 1.17505 64.9816 1.17505 68.6855V68.6855C1.17505 72.3895 4.17768 75.3921 7.88162 75.3921L43.5606 75.3921L43.5606 61.9789L7.88163 61.9789Z"
                                        stroke="#363636" stroke-width="2"></path>
                                    <g filter="url(#filter3_i_2066_24649)">
                                        <path
                                            d="M144.428 19.5942C152.725 19.5942 159.45 26.3201 159.45 34.6169L159.45 57.151C159.45 65.4478 152.725 72.1737 144.428 72.1737L129.942 72.1737L129.942 19.5942L144.428 19.5942Z"
                                            fill="#F6F6F6"></path>
                                    </g>
                                    <path
                                        d="M144.428 19.5942C152.725 19.5942 159.45 26.3201 159.45 34.6169L159.45 57.151C159.45 65.4478 152.725 72.1737 144.428 72.1737L129.942 72.1737L129.942 19.5942L144.428 19.5942Z"
                                        stroke="#363636" stroke-width="2"></path>
                                    <defs>
                                        <filter id="filter0_i_2066_24649" x="42.5601" y="0.888123" width="88.3806"
                                            height="89.9902" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                                result="shape">
                                            </feBlend>
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                            </feColorMatrix>
                                            <feOffset dx="-12" dy="10"></feOffset>
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1">
                                            </feComposite>
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                            </feColorMatrix>
                                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24649">
                                            </feBlend>
                                        </filter>
                                        <filter id="filter1_i_2066_24649" x="0.175049" y="14.8383" width="44.3855"
                                            height="15.4131" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                                result="shape">
                                            </feBlend>
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                            </feColorMatrix>
                                            <feOffset dx="5" dy="5"></feOffset>
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1">
                                            </feComposite>
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                            </feColorMatrix>
                                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24649">
                                            </feBlend>
                                        </filter>
                                        <filter id="filter2_i_2066_24649" x="0.175049" y="60.9789" width="44.3855"
                                            height="15.4131" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                                result="shape">
                                            </feBlend>
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                            </feColorMatrix>
                                            <feOffset dx="5" dy="5"></feOffset>
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1">
                                            </feComposite>
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                            </feColorMatrix>
                                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24649">
                                            </feBlend>
                                        </filter>
                                        <filter id="filter3_i_2066_24649" x="128.942" y="18.5942" width="31.5089"
                                            height="54.5795" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                                result="shape">
                                            </feBlend>
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                            </feColorMatrix>
                                            <feOffset dx="-8" dy="8"></feOffset>
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1">
                                            </feComposite>
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                            </feColorMatrix>
                                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24649">
                                            </feBlend>
                                        </filter>
                                    </defs>
                                </svg> -->
                            </div>

                            <div class="hero_img-phone-plug-left w-embed">
                                <img src="https://media.iquanta.in/ui_images/new-home/left-plug.svg">
                                <!-- <svg width="100%" height="100%" viewBox="0 0 161 106" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g filter="url(#filter0_i_2066_24655)">
                                        <path
                                            d="M49.7857 9.39887C39.4147 9.39887 31.0073 17.8062 31.0073 28.1773L31.0073 78.6107C31.0073 88.9817 39.4147 97.3891 49.7857 97.3891L99.6826 97.3891L99.6826 9.39887L49.7857 9.39887Z"
                                            fill="#F6F6F6"></path>
                                    </g>
                                    <path
                                        d="M49.7857 9.39887C39.4147 9.39887 31.0073 17.8062 31.0073 28.1773L31.0073 78.6107C31.0073 88.9817 39.4147 97.3891 49.7857 97.3891L99.6826 97.3891L99.6826 9.39887L49.7857 9.39887Z"
                                        stroke="#D9D9D9" stroke-width="2"></path>
                                    <path
                                        d="M49.7857 9.39887C39.4147 9.39887 31.0073 17.8062 31.0073 28.1773L31.0073 78.6107C31.0073 88.9817 39.4147 97.3891 49.7857 97.3891L99.6826 97.3891L99.6826 9.39887L49.7857 9.39887Z"
                                        stroke="#363636" stroke-width="2"></path>
                                    <g filter="url(#filter1_i_2066_24655)">
                                        <path
                                            d="M14.3761 28.7143C7.26458 28.7143 1.49951 34.4794 1.49951 41.5909L1.49951 65.198C1.49951 72.3096 7.26457 78.0747 14.3761 78.0747L31.0084 78.0747L31.0084 28.7143L14.3761 28.7143Z"
                                            fill="#F6F6F6"></path>
                                    </g>
                                    <path
                                        d="M14.3761 28.7143C7.26458 28.7143 1.49951 34.4794 1.49951 41.5909L1.49951 65.198C1.49951 72.3096 7.26457 78.0747 14.3761 78.0747L31.0084 78.0747L31.0084 28.7143L14.3761 28.7143Z"
                                        stroke="#D9D9D9" stroke-width="2"></path>
                                    <path
                                        d="M14.3761 28.7143C7.26458 28.7143 1.49951 34.4794 1.49951 41.5909L1.49951 65.198C1.49951 72.3096 7.26457 78.0747 14.3761 78.0747L31.0084 78.0747L31.0084 28.7143L14.3761 28.7143Z"
                                        stroke="#363636" stroke-width="2"></path>
                                    <g filter="url(#filter2_i_2066_24655)">
                                        <rect width="103.013" height="17.1688" rx="8.58441"
                                            transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.6831 1.88812)"
                                            fill="#F6F6F6">
                                        </rect>
                                    </g>
                                    <rect width="103.013" height="17.1688" rx="8.58441"
                                        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.6831 1.88812)"
                                        stroke="#363636" stroke-width="2"></rect>
                                    <g filter="url(#filter3_i_2066_24655)">
                                        <path
                                            d="M68.1677 52.7215L68.1677 46.8881L92.9858 55.0548L78.804 55.0548L78.804 60.8881L53.9858 52.7215L68.1677 52.7215Z"
                                            fill="green"></path>
                                    </g>
                                    <g filter="url(#filter4_i_2066_24655)">
                                        <path
                                            d="M152.531 83.4418C156.235 83.4418 159.237 80.4392 159.237 76.7353V76.7353C159.237 73.0313 156.235 70.0287 152.531 70.0287L116.852 70.0287L116.852 83.4418L152.531 83.4418Z"
                                            fill="#F6F6F6"></path>
                                    </g>
                                    <path
                                        d="M152.531 83.4418C156.235 83.4418 159.237 80.4392 159.237 76.7353V76.7353C159.237 73.0313 156.235 70.0287 152.531 70.0287L116.852 70.0287L116.852 83.4418L152.531 83.4418Z"
                                        stroke="#363636" stroke-width="2"></path>
                                    <g filter="url(#filter5_i_2066_24655)">
                                        <path
                                            d="M152.531 37.3012C156.235 37.3012 159.237 34.2986 159.237 30.5946V30.5946C159.237 26.8907 156.235 23.8881 152.531 23.8881L116.852 23.8881L116.852 37.3012L152.531 37.3012Z"
                                            fill="#F6F6F6"></path>
                                    </g>
                                    <path
                                        d="M152.531 37.3012C156.235 37.3012 159.237 34.2986 159.237 30.5946V30.5946C159.237 26.8907 156.235 23.8881 152.531 23.8881L116.852 23.8881L116.852 37.3012L152.531 37.3012Z"
                                        stroke="#363636" stroke-width="2"></path>
                                    <defs>
                                        <filter id="filter0_i_2066_24655" x="30.0073" y="8.39886" width="70.6753"
                                            height="89.9902" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                                result="shape">
                                            </feBlend>
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                            </feColorMatrix>
                                            <feOffset dx="10" dy="10"></feOffset>
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1">
                                            </feComposite>
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                            </feColorMatrix>
                                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24655">
                                            </feBlend>
                                        </filter>
                                        <filter id="filter1_i_2066_24655" x="0.499512" y="27.7143" width="31.5089"
                                            height="51.3604" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                                result="shape">
                                            </feBlend>
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                            </feColorMatrix>
                                            <feOffset dx="8" dy="8"></feOffset>
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1">
                                            </feComposite>
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                            </feColorMatrix>
                                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24655">
                                            </feBlend>
                                        </filter>
                                        <filter id="filter2_i_2066_24655" x="98.6831" y="0.888123" width="19.1688"
                                            height="105.013" filterUnits="userSpaceOnUse"
                                            color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix"
                                                result="shape">
                                            </feBlend>
                                            <feColorMatrix in="SourceAlpha" type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha">
                                            </feColorMatrix>
                                            <feOffset dx="6" dy="6"></feOffset>
                                            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1">
                                            </feComposite>
                                            <feColorMatrix type="matrix"
                                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0">
                                            </feColorMatrix>
                                            <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2066_24655">
                                            </feBlend>
                                        </filter>

                                    </defs>
                                </svg> -->
                            </div>
                            <img width="338" loading="eager" alt="CAT Coaching" class="hero_img-phone-frame"
                                src="https://media.iquanta.in/ui_images/mobile-video-bg.png">

                            <div class="mobile-scrollable-content">

                                <div class="mobile-scrollable-content-inside">

                                    <div class="video-mobile-in" *ngIf="!playVideoFlag"
                                        (click)="playVideoFlag = !playVideoFlag">
                                        <img width="364" loading="eager" alt="CAT 2025 Course"
                                            class="hero_img-phone-screenshot"
                                            [src]="thumbnail">
                                    </div>
                                    <ng-container *ngIf="playVideoFlag">
                                        <iframe loading="lazy"
                                            [src]="videoLinkMain"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowfullscreen=""></iframe>
                                    </ng-container>

                                    <div class="content">
                                        <div
                                            class="inside-box-mobile d-flex justify-content-between align-items-center">
                                            <div>
                                                <h2 class="f-bold">CAT 2025 New Batch</h2>
                                                <h6>Flagship Full Course | Starting From April</h6>
                                            </div>
                                            <div class="text-right rating">
                                                <p>
                                                    <i class="bi bi-star-fill"></i>
                                                    <i class="bi bi-star-fill"></i>
                                                    <i class="bi bi-star-fill"></i>
                                                    <i class="bi bi-star-fill"></i>
                                                    <i class="bi bi-star-fill"></i>
                                                </p>
                                                <span class="rating-text f-medium">41894 Reviews</span>
                                            </div>

                                        </div>

                                        <div class="contest-list-card">
                                            <p [innerHTML]="productDetails?.description | safeHtml"></p>
                                        </div>

                                        <!-- <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div>

                                        <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div>

                                        <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div>

                                        <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div>

                                        <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div>

                                        <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div>

                                        <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div>

                                        <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div>
                                        <div class="chips-inside-mobile d-flex f-bold">
                                            <span>20,000+ Questions</span>
                                            <span>20,000+ Questions</span>
                                        </div> -->

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="line-mobile-left"></div>
                    <div class="line-mobile-left left2"></div>
                    <div class="line-mobile-left right"></div>
                    <div class="line-mobile-left right right2"></div>


                    <div class="mobile-add-ons" >

                        <div class="row">
                            <div class="col-6">
                                <div class="single-card-element"
                                    [ngClass]="{'check-active': addonListIds.includes('403')}">
                                    <p>CAT<br> Books </p>
                                    <span>Latest Material</span>
                                    <div (click)="addon('403', '')" class="dot">
                                        <i *ngIf="addonListIds.includes('403')" class="bi bi-check-circle-fill"></i>
                                    </div>
                                    <div class="product_price">₹5,499</div>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="single-card-element se-02"
                                    [ngClass]="{'check-active': addonListIds.includes('316')}">
                                    <p>Non CAT<br>
                                        Exams </p>
                                    <span>Other Management
                                        Exams Full Course</span>
                                    <div (click)="addon('316', '')" class="dot">
                                        <i *ngIf="addonListIds.includes('316')" class="bi bi-check-circle-fill"></i>
                                    </div>
                                    <div class="product_price">₹19,499</div>

                                </div>
                            </div>

                            <div class="col-6">
                                <div class="single-card-element se-right check-active">
                                    <div class="product_price pp-1">Worth ₹5,499</div>

                                    <p>CAT<br> Mocks </p>
                                    <span>AI Powered</span>
                                    <div class="dot">
                                        <i class="bi bi-check-circle-fill"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="single-card-element se-right se-02"
                                    [ngClass]="{'check-active': addonListIds.includes('439')}">
                                    <p>IIM ABC Batch </p>
                                    <span>7500 CAT Level Qs.</span>
                                    <div (click)="addon('439', '')" class="dot">
                                        <i *ngIf="addonListIds.includes('439')" class="bi bi-check-circle-fill"></i>
                                    </div>

                                    <div class="product_price">₹5,499</div>

                                </div>
                            </div>
                           
                        </div>
                    </div>




                </div>
                <div class="incl-features" id="incl-features">
                    <div class="row">
                        <div class="col-12">
                            <div class="single-card-element se-03 check-active" >
                                <p>CAT Crash Course   </p>
                                <span>2 Month</span>
                                <div  class="dot">
                                    <i  class="bi bi-check-circle-fill"></i>
                                </div>
                               
                                <div class="product_price ">Worth ₹19,499</div>
                            </div>
                        </div>
                    </div>
                    <div class="curvide-lines curvide-lines1">
                        <div class="img-text">
                            <h4> <span>24*7</span> Doubt Solving</h4>
                        </div>
                    </div>

                    <div class="curvide-lines">
                        <div class="img-text">
                            <h4> <span>400+ Live</span> Classes</h4>
                        </div>
                    </div>

                   
                    <div class="curvide-lines curvide-lines5">
                        <div class="img-text">
                            <h4><span>1000+</span> Assignments</h4>
                        </div>
                    </div>
                    <div class="curvide-lines curvide-lines2">
                        <div class="img-text">
                            <h4><span>Exclusive Material</span> </h4>
                            <h5>Non engs. QA </h5>
                            <h5>engs. varc </h5>
                            <h5>lrdi inception </h5>
                            <h5>lrdi essential </h5>
                            <h5>varc essentials </h5>
                        </div>
                    </div>

                    <div class="curvide-lines curvide-lines4">
                        <div class="img-text">
                            <h4> <span>Daily Application</span> Classes</h4>
                            <p>iQuanta’s Unique way of teaching <br>
                                where mentors help you solve questions <br>
                                covered in Live classes along with <br>instant doubt solving.</p>
                        </div>
                    </div>



                </div>

                <div #stickyFooter [class.fixed]="isFixed"
                    class="sticky-footer course-buying-card d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center pl-3">
                        <h2 class="mb-0">{{totalAmount|currency}}</h2>
                        <span class="ml-2"><del>{{productDetails?.actual_price|currency}}</del></span>
                    </div>
                    <!-- <div class="coupon-tag d-flex flex-column  ml-auto">
                        <img src="https://media.iquanta.in/ui_images/coupon-tag.webp" alt="CAT Coaching">
                    </div> -->
                    <button (click)="buynow()" class="btn buy_now">Buy Now</button>
                </div>
                <div #endSentinel class="sentinel"></div>
            </div>

        </div>

    </div>
</div>